import React from 'react';
import './FacebookDataDeletion.css';

const DataDeletionInstructions = () => {
  const handleRemove = () => {
    // Open the Facebook settings page to remove the app
    window.open('https://www.facebook.com/settings?tab=applications');
  };

  return (
    <div className="data-deletion-instructions">
      <p>
        If you want to delete your activities for our games, you can remove your information by following these steps:
      </p>
      <ol>
        <li>Go to your Facebook Account’s Setting &amp; Privacy. Click “Settings”</li>
        <li>Look for “Apps and Websites” and you will see all of the apps and websites you linked with your Facebook.</li>
        <li>Search and Click "Game Name" in the search bar.</li>
        <li>Scroll and click “Remove”.</li>
        <li>Congratulations, you have successfully removed your app activities.</li>
      </ol>
      <button onClick={handleRemove}>Go to Facebook Settings</button>
    </div>
  );
};

export default DataDeletionInstructions;